import React from "react";
import LegalLayout from "../../components/portal/LegalLayout";

export default function RefundPolicyPage() {
  return (
    <LegalLayout title="Refund Policy">
      <p>
        At Antarctic Press, we are committed to ensuring a safe and trustworthy experience for readers, customers, project creators and backers. Please read our refund policy carefully before making a pledge or purchase.
      </p>

      <h2>1. All Pledges Are Final</h2>
      <p>
        When you back a project on Fund Go, you are pledging to support a creator's campaign and vision. All pledges are considered final and non-refundable unless the campaign is canceled or fails to meet certain platform requirements.
      </p>

      <h2>2. Refunds for Canceled Campaigns</h2>
      <p>
        If a campaign is canceled before its funding period ends, or if it is removed for violating Antarctic Press’s terms, you will automatically receive a full refund of your pledge amount.
      </p>

      <h2>3. Creator Responsibility</h2>
      <p>
        Project creators are solely responsible for fulfilling rewards. While Antarctic Press facilitates the campaign process, we do not guarantee delivery or refund beyond the conditions outlined here.
      </p>

      <h2>4. Dispute Resolution</h2>
      <p>
        If you have concerns regarding a campaign you’ve backed, we recommend contacting the creator directly. If a dispute cannot be resolved, Antarctic Press may review the situation and issue a refund at our discretion.
      </p>

      <h2>5. Refund Processing Time</h2>
      <p>
        Approved refunds will typically be processed back to the original payment method within 5–10 business days, depending on your payment provider.
      </p>

      <h2>6. Contact Us</h2>
      <p>
        If you have any questions or concerns about this policy, please contact us at <a href="mailto:support@antarcticpress.com">support@antarcticpress.com</a>.
      </p>
    </LegalLayout>
  );
}
